module.exports = "./dist/bonbons.svg?3f2262843d11d7f428b6901ef2380ace";


//////////////////
// WEBPACK FOOTER
// ./src/img/bonbons.svg
// module id = 97
// module chunks = 0